import React from 'react'
import Feedback from '../feedback'

const FeedbackEn = () => {
    return <Feedback languageCode="en" />
}

export default FeedbackEn
